// import '@sophocles/components/MultiSelect/styles.scss';

// import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
// import PropTypes from 'prop-types';
// import React, { useCallback, useEffect, useState } from 'react';
// import { AutoSizer, InfiniteLoader, List } from 'react-virtualized';

// import SelectList from '@sophocles/components/MultiSelect/SelectList';
// import { Set } from 'immutable';

// const MultiSelect = ({
//   selectedItems,
//   fetchUnselectedItems, // Function to fetch paginated unselected items
//   onSelectItem,
//   onDeselectItem,
//   selectedTitle = 'Selected Items',
//   unselectedTitle = 'Available Items',
//   renderRow,
//   listHeight = 300,
//   listWidth = 400,
//   containerStyle,
//   showCounts = true,
// }) => {
//   const [unselectedItems, setUnselectedItems] = useState([]);
//   const [pagination, setPagination] = useState({ limit: 10, offset: 0 });
//   const [loading, setLoading] = useState(false);
//   const [hasMore, setHasMore] = useState(true);
//   const [totalCount, setTotalCount] = useState(0);

//   // ✅ Fetch items while preventing duplicate loads
//   const loadMoreRows = ({ startIndex, stopIndex }) => {
//     // if (loading || !hasMore) return;

//     setLoading(true);

//     setPagination(prev => ({ ...prev, offset: startIndex }));

//     return fetchUnselectedItems({ limit: pagination.limit, offset: startIndex })
//       .then(response => {
//         setTotalCount(response.count);

//         const results = response.results ?? [];

//         setUnselectedItems(prevItems => {
//           const uniqueItems = new Map();
//           [...prevItems, ...results].forEach(item => uniqueItems.set(item.id, item));
//           return Array.from(uniqueItems.values()); // Prevents duplicates
//         });

//         return results;
//       })
//       .catch(error => {
//         console.error('Failed to fetch unselected items:', error);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };

//   // ✅ Load first batch on mount
//   useEffect(() => {
//     loadMoreRows({ startIndex: 0, stopIndex: pagination.limit });
//   }, []);

//   // ✅ Ensure `isRowLoaded` works correctly
//   const isRowLoaded = ({ index }) => index < unselectedItems.length;

//   // ✅ Render rows inside the virtualized list
//   const rowRenderer = ({ index, key, style }) => {
//     if (!isRowLoaded({ index })) {
//       return (
//         <div key={key} style={{ ...style, textAlign: 'center', padding: '10px' }}>
//           Loading...
//         </div>
//       );
//     }

//     const item = unselectedItems[index];

//     return (
//       <div
//         key={key}
//         style={{ ...style, cursor: 'pointer' }}
//         onClick={() => onSelectItem(item)}
//         role="button"
//         tabIndex={0}
//         onKeyDown={event => event.key === 'Enter' && onSelectItem(item)}
//       >
//         {renderRow(item, () => onSelectItem(item))}
//       </div>
//     );
//   };

//   return (
//     <div style={containerStyle || { display: 'flex', justifyContent: 'center' }}>
//       {/* Unselected Items List */}
//       <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: `0 1 ${listWidth}px` }}>
//         <h6>{unselectedTitle}</h6>
//         <AutoSizer disableHeight>
//           {({ width }) => (
//             <InfiniteLoader isRowLoaded={isRowLoaded} loadMoreRows={loadMoreRows} rowCount={totalCount}>
//               {({ onRowsRendered, registerChild }) => (
//                 <List
//                   ref={registerChild}
//                   height={listHeight}
//                   width={width}
//                   rowHeight={50}
//                   rowCount={hasMore ? totalCount : unselectedItems.length}
//                   rowRenderer={rowRenderer}
//                   onRowsRendered={onRowsRendered}
//                 />
//               )}
//             </InfiniteLoader>
//           )}
//         </AutoSizer>
//         {loading && <p>Loading...</p>}
//         {showCounts && (
//           <div style={{ alignSelf: 'left', padding: '4px 8px', fontSize: '14px' }}>
//             count: {unselectedItems.length}/{totalCount}
//           </div>
//         )}
//       </div>

//       {/* Swap Icon */}
//       <div style={{ margin: '10px', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
//         <SwapHorizIcon />
//       </div>

//       {/* Selected Items List */}
//       <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: `0 1 ${listWidth}px` }}>
//         <h6>{selectedTitle}</h6>
//         <SelectList data={Set(selectedItems)} onSelect={onDeselectItem} rowGenerator={renderRow} height={listHeight} />
//         {showCounts && (
//           <div style={{ alignSelf: 'left', padding: '4px 8px', fontSize: '14px' }}>count: {selectedItems.length}</div>
//         )}
//       </div>
//     </div>
//   );
// };

// MultiSelect.propTypes = {
//   selectedItems: PropTypes.array.isRequired,
//   fetchUnselectedItems: PropTypes.func.isRequired, // API fetch function
//   onSelectItem: PropTypes.func.isRequired,
//   onDeselectItem: PropTypes.func.isRequired,
//   selectedTitle: PropTypes.string,
//   unselectedTitle: PropTypes.string,
//   renderRow: PropTypes.func.isRequired,
//   listHeight: PropTypes.number,
//   listWidth: PropTypes.number,
//   containerStyle: PropTypes.object,
//   showCounts: PropTypes.bool,
// };

// export default MultiSelect;

import '@sophocles/components/MultiSelect/styles.scss';

import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import React from 'react';

import SelectList from '@sophocles/components/MultiSelect/SelectList';

class MultiSelect extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      selectedData,
      unSelectedData,
      onSelectData,
      onUnSelectData,
      selectedTitle,
      unSelectedTitle,
      rowGenerator,
      listHeight,
      containerStyle,
      onTablet,
    } = this.props;

    return (
      <div style={containerStyle || { display: onTablet ? 'block' : 'flex', justifyContent: 'center' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flex: '0 1 400px',
          }}
        >
          <h6>{unSelectedTitle}</h6>
          <SelectList data={unSelectedData} onSelect={onSelectData} rowGenerator={rowGenerator} height={listHeight} />
          <div style={{ alignSelf: 'left', padding: '4px 8px', fontSize: '14px' }}>count: {unSelectedData.size}</div>
        </div>
        <div
          style={{
            margin: '10px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <SwapHorizIcon />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flex: '0 1 400px',
          }}
        >
          <h6>{selectedTitle}</h6>
          <SelectList data={selectedData} onSelect={onUnSelectData} rowGenerator={rowGenerator} height={listHeight} />
          <div style={{ alignSelf: 'left', padding: '4px 8px', fontSize: '14px' }}>count: {selectedData.size}</div>
        </div>
      </div>
    );
  }
}

export default MultiSelect;
